if (window.publicPath) __webpack_public_path__ = window.publicPath;

require('./account-helpers.js');
require('./account-info.js');
require('./order-detail.js');
require('./order-tracking.js');
require('./app');
require('lessRoot/account/account.less');

(function($) {
	$(document).ready(function() {
		Blain.CustomerInfo.initCustomerInfo("#customerInfo");
		Blain.CustomerInfo.initAccountTabNavigation();
		Blain.CustomerAddress.initAddressBook("#addressBook");
		Blain.CustomerCreditCard.initCreditCardList("#creditCards");
		Blain.OrderDetail.initOrderDetail();
		Blain.OrderTracking.init();
		Blain.AccountHome.init();
		Blain.TaxExemption.init();
	});
})(jQuery);